import apiClient, { extractData } from './client';

export async function getPermitRequests(params = {}) {
  const response = await apiClient.get('/permit', { params });
  return extractData(response);
}

/** رصيد الأذونات الشهري (أول ساعتين مجاناً، ثم ساعتين ×1.5، حد أقصى 4 ساعات) */
export async function getPermitBalance(params = {}) {
  const response = await apiClient.get('/permit/balance', { params });
  return extractData(response);
}

export async function getPermit(id) {
  const response = await apiClient.get(`/permit/${id}`);
  return extractData(response);
}

export async function getPermitHistory(id) {
  const response = await apiClient.get(`/permit/${id}/history`);
  return extractData(response);
}

export async function createPermitRequest(data) {
  const response = await apiClient.post('/permit', data);
  return extractData(response);
}

export async function approvePermit(id, data = {}) {
  const response = await apiClient.post(`/permit/${id}/approve`, data);
  return extractData(response);
}

export async function rejectPermit(id, data = {}) {
  const response = await apiClient.post(`/permit/${id}/reject`, data);
  return extractData(response);
}

export async function cancelPermit(id) {
  const response = await apiClient.post(`/permit/${id}/cancel`);
  return extractData(response);
}

/**
 * HR: grant extra monthly permit hours (FREE or EMPLOYEE_PAID).
 * @param {{ target: string, departmentId?: string, employeeIds?: string[], year: number, month: number, hours: number, chargeType: 'FREE'|'EMPLOYEE_PAID', reason?: string }} data
 */
export async function grantPermitHours(data) {
  const response = await apiClient.post("/permit/grant-hours", data);
  return extractData(response);
}

/** HR: list permit-hour grants */
export async function listPermitHourGrants(params = {}) {
  const response = await apiClient.get("/permit/grant-hours", { params });
  return extractData(response);
}

/** HR: update a permit-hour grant */
export async function updatePermitHourGrant(id, data) {
  const response = await apiClient.patch(`/permit/grant-hours/${id}`, data);
  return extractData(response);
}

/** HR: delete a permit-hour grant */
export async function deletePermitHourGrant(id) {
  const response = await apiClient.delete(`/permit/grant-hours/${id}`);
  return extractData(response);
}

/**
 * HR: preview converting a late / early-leave day into an hour-permit.
 * @param {{ employeeId: string, date: string }} params
 */
export async function previewConvertAttendanceToPermit(params = {}) {
  const response = await apiClient.get("/permit/convert-attendance/preview", {
    params,
  });
  return extractData(response);
}

/**
 * HR: convert uncovered late / early-leave minutes to an approved permit
 * using the employee's remaining monthly hours.
 * @param {{ employeeId: string, date: string, kinds?: string[], reason?: string }} data
 */
export async function convertAttendanceToPermit(data) {
  const response = await apiClient.post("/permit/convert-attendance", data);
  return extractData(response);
}

/**
 * HR: move a permit from a wrong date to the correct date.
 * @param {string} id
 * @param {{ newDate: string, reason?: string }} data
 */
export async function movePermitDate(id, data) {
  const response = await apiClient.post(`/permit/${id}/move-date`, data);
  return extractData(response);
}
